export const useDevice = () => {
  return {
    isTouchable: () => 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    onTouchStart: (event: Event) => event.type === 'touchstart',
    onTouchMove: (event: Event) => event.type === 'touchmove',
    onTouchEnd: (event: Event) => event.type === 'touchend',
  };
};
